import { productTile } from 'assets/components';

import './featuredProducts.scss';

const destroy = function destroyFeaturedProducts() {
  productTile.destroy();
};

const init = function initFeaturedProducts() {
  productTile.init();
};

export default {
  destroy,
  init,
};
